/**
 * How a catalog item is counted.
 *
 *   SERIALIZED  every physical unit is its own asset with an HN-AST tag,
 *               a serial, a status and a history (tablets, scanners, printers,
 *               Edge appliances, controllers).
 *   QUANTITY    fungible units counted by SKU and location, never given an
 *               individual identity (Cat6 patch cables, chargers, paper rolls,
 *               Velcro, labels).
 *
 * The distinction is a property of the CATALOG ITEM, not of a physical thing,
 * so a SKU that starts quantity-managed can be promoted to serialized later
 * without the assets it already produced changing identity. Nothing in this
 * package encodes that promotion; it only names the two states so the rest of
 * the system can refuse to, say, mint an asset tag for a quantity SKU.
 */

export const TRACKING_TYPES = ['SERIALIZED', 'QUANTITY'] as const;
export type TrackingType = (typeof TRACKING_TYPES)[number];

export const TRACKING_TYPE_LABEL: Readonly<Record<TrackingType, string>> = {
  SERIALIZED: 'Serialized',
  QUANTITY: 'Quantity',
};

export function isTrackingType(v: unknown): v is TrackingType {
  return typeof v === 'string' && (TRACKING_TYPES as readonly string[]).includes(v);
}
